var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcHelp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#AAA",
  fillRule: "evenodd",
  d: "M14.833 8A6.833 6.833 0 1 0 1.166 8a6.833 6.833 0 0 0 13.667 0M8.471 4.38a2.417 2.417 0 0 0-2.888 2.37.667.667 0 0 0 1.334 0A1.083 1.083 0 1 1 8 7.834a.667.667 0 0 0-.667.666V9a.667.667 0 0 0 1.33.074A2.416 2.416 0 0 0 8.47 4.38m.279 6.87a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0",
  clipRule: "evenodd"
})));
export default SvgIcHelp;